import apiClient from './apiClient';

export const walletService = {
  async getWalletBalance() {
    const response = await apiClient.get('/wallet/balance');
    if (response && response.isSuccessful) {
      return response.content;
    }
    throw new Error(response?.message || 'Failed to retrieve wallet balance');
  }
};

export default walletService;
